import { render, staticRenderFns } from "./StudyInformationTable.vue?vue&type=template&id=071fd126"
import script from "./StudyInformationTable.vue?vue&type=script&lang=js"
export * from "./StudyInformationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports